import { isNonEmptyArray } from 'app-shared/utils';

import { EXPECTED_GRAPHQL_ERROR_CODES } from '@/apollo/constants/ExpectedGraphqlErrorCodes';
import { getGraphqlErrorExtensions } from '@/apollo/utils/getGraphqlErrorExtensions';

// Unexpected: the server couldn't be reached, crashed, or answered with a code
// no screen plans for.
export const isUnexpectedError = (error: unknown) => {
  const graphqlErrorExtensionsList = getGraphqlErrorExtensions(error);

  if (!isNonEmptyArray(graphqlErrorExtensionsList)) {
    return true;
  }

  return graphqlErrorExtensionsList.some(
    ({ code }) =>
      !EXPECTED_GRAPHQL_ERROR_CODES.some(
        (expectedGraphqlErrorCode) => expectedGraphqlErrorCode === code,
      ),
  );
};
